<label
  [class.large]="size === 'large'"
  [class.cb-align-top]="align === 'top'">
  <input
    type="checkbox"
    [checked]="isChecked"
    [attr.disabled]="isDisabled"
    [attr.indeterminate]="isIndeterminate ? 'true' : null" />
  <span class="checkbox">
    <i
      [class.!opacity-0]="isIndeterminate"
      class="icon-check"></i>

    <div
      *ngIf="isIndeterminate"
      class="absolute top-1/2 -mt-[0.75px] h-[1.5px] w-full bg-white"></div>
  </span>
  <span
    #labelContent
    [class.u-padding-left-10]="labelContent.innerHTML.length">
    <ng-content></ng-content>
  </span>
</label>
